export const heroData = {
  title: '开云足球',
  subtitle: '极致足球体验平台',
  description: '专注足球赛事、数据分析与互动体验的综合平台。实时赛事资讯、精准数据支持、沉浸式足球互动，一切尽在开云足球。',
  ctaText: '立即加入',
  ctaSubtext: '已有超过 200 万用户选择开云足球',
  ctaLink: '/category/events',
};

export const services = [
  {
    id: 'live',
    icon: 'ri-live-line',
    title: '赛事直播',
    description: '覆盖全球五大联赛、欧冠、世界杯等顶级赛事，高清流畅直播，多路信号自由切换，决不错过任何精彩瞬间。',
    link: '/category/live',
  },
  {
    id: 'data',
    icon: 'ri-bar-chart-2-line',
    title: '数据分析',
    description: '基于 AI 算法的深度数据挖掘，提供球队战力评估、球员状态追踪、历史交锋数据等多维度专业分析。',
    link: '/category/data',
  },
  {
    id: 'interactive',
    icon: 'ri-gamepad-line',
    title: '足球互动',
    description: '丰富的足球竞猜、梦幻联赛、社区讨论等互动玩法，让您在看球的同时享受更多足球乐趣。',
    link: '/category/interactive',
  },
  {
    id: 'news',
    icon: 'ri-newspaper-line',
    title: '足球资讯',
    description: '7×24 小时不间断更新，第一时间获取转会动态、赛前分析、赛后战报等最新足球资讯。',
    link: '/category/live',
  },
];

export const matches = [
  {
    id: 1,
    league: '英超联赛',
    homeTeam: '曼城',
    awayTeam: '阿森纳',
    homeScore: 2,
    awayScore: 1,
    time: '2026-08-10 03:00',
    status: '已结束',
    icon: 'ri-football-line',
  },
  {
    id: 2,
    league: '西甲联赛',
    homeTeam: '皇家马德里',
    awayTeam: '巴塞罗那',
    homeScore: null,
    awayScore: null,
    time: '2026-08-12 04:00',
    status: '即将开始',
    icon: 'ri-timer-line',
  },
  {
    id: 3,
    league: '德甲联赛',
    homeTeam: '拜仁慕尼黑',
    awayTeam: '多特蒙德',
    homeScore: 3,
    awayScore: 3,
    time: '2026-08-09 00:30',
    status: '已结束',
    icon: 'ri-football-line',
  },
  {
    id: 4,
    league: '欧冠联赛',
    homeTeam: '利物浦',
    awayTeam: 'AC米兰',
    homeScore: null,
    awayScore: null,
    time: '2026-08-14 03:00',
    status: '即将开始',
    icon: 'ri-timer-line',
  },
];

export const stats = [
  { value: '200万+', label: '注册用户', icon: 'ri-user-star-line' },
  { value: '50+', label: '覆盖联赛', icon: 'ri-global-line' },
  { value: '99.9%', label: '直播稳定性', icon: 'ri-shield-check-line' },
  { value: '24/7', label: '全天候服务', icon: 'ri-24-hours-line' },
];

export const activities = [
  {
    id: 1,
    title: '新用户专享福利',
    description: '注册即送 88 元体验金，参与足球竞猜赢取更多奖励',
    tag: '限时活动',
    link: '/category/events',
    imageSeq: 'activity-new-user',
  },
  {
    id: 2,
    title: '欧冠决赛竞猜',
    description: '参与欧冠决赛比分竞猜，瓜分百万奖池，最高单注奖励 10 万元',
    tag: '热门',
    link: '/category/events',
    imageSeq: 'activity-ucl',
  },
  {
    id: 3,
    title: '每日签到有礼',
    description: '连续签到 7 天即可获得额外奖励，积分可兑换精美足球周边',
    tag: '长期活动',
    link: '/category/events',
    imageSeq: 'activity-checkin',
  },
];

export const featuredArticles = [
  {
    id: 1,
    title: '2026世界杯预选赛亚洲区最新战况分析',
    summary: '亚洲区预选赛进入白热化阶段，各队争夺出线名额异常激烈。本文详细分析各小组最新形势与关键战役。',
    category: '赛事分析',
    date: '2026-08-06',
    readTime: '8分钟',
    link: '/article/1',
  },
  {
    id: 2,
    title: '开云足球数据团队：用AI技术解析足球战术',
    summary: '开云足球数据团队深度运用人工智能技术，从海量比赛数据中提取战术规律，为球迷提供专业的赛前预测与赛后复盘。',
    category: '平台动态',
    date: '2026-08-04',
    readTime: '6分钟',
    link: '/article/2',
  },
  {
    id: 3,
    title: '五大联赛夏季转会窗口全面盘点',
    summary: '夏季转会窗即将关闭，各豪门引援动作频频。本文全面梳理五大联赛今夏重要转会，分析各队新赛季阵容变化。',
    category: '转会资讯',
    date: '2026-08-02',
    readTime: '10分钟',
    link: '/article/3',
  },
];